import GenericDataGrid from './GenericDataGrid';

export default GenericDataGrid;
